import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DosenConfirmModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  /** No close button: the modal is answered with one of its own buttons. */
  hideClose?: boolean;
}

const DosenConfirmModal: React.FC<DosenConfirmModalProps> = ({ open, onClose, title, children, hideClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 550,
          background: '#0F0F0F',
          borderRadius: '8px',
          outline: '1px solid #444444',
          outlineOffset: '-1px',
          overflow: 'hidden'
        }
      }}
    >
      <Box sx={{ borderBottom: '1px solid #444444', px: '25px', py: '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Typography
            sx={{
              flex: 1,
              color: 'var(--Text-text-primary, #FDFDFD)',
              fontSize: 18,
              fontWeight: 700,
              fontFamily: 'Inter, sans-serif'
            }}
          >
            {title}
          </Typography>
          {!hideClose && (
            <IconButton onClick={onClose} sx={{ p: 0.75 }}>
              <CloseIcon sx={{ fontSize: '25px', color: '#FDFDFD' }} />
            </IconButton>
          )}
        </Box>
      </Box>
      <Box sx={{ px: 3, py: 2.5, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        {children}
      </Box>
    </Dialog>
  );
};

export default DosenConfirmModal;
